// @flow

/* eslint-disable new-cap */
import { get } from 'lodash';

import createReducer from 'Store/utils/createReducer';

import {
  FETCH_BOOKING_ATTENDEES_PACKAGE,
  FETCH_BOOKING_ATTENDEES_PACKAGE_RESOLVED,
  FETCH_BOOKING_ATTENDEES_PACKAGE_REJECTED,
  CLEAR_BOOKING_ATTENDEES_PACKAGE,
} from 'Store/member-space/booking/booking.constants';

const initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null,
};

export default createReducer(initialState, {
  [FETCH_BOOKING_ATTENDEES_PACKAGE](state: ReduxState): ReduxState {
    return {
      ...state,
      isLoading: true,
    };
  },
  [FETCH_BOOKING_ATTENDEES_PACKAGE_RESOLVED](state: ReduxState, action): ReduxState {
    return {
      ...state,
      data: {
        attendees: get(action, 'payload.userBooking.attendees') || [],
        package: get(action, 'payload.package'),
      },
      isLoaded: true,
      isLoading: false,
    };
  },
  [FETCH_BOOKING_ATTENDEES_PACKAGE_REJECTED](state: ReduxState, action): ReduxState {
    return {
      ...state,
      isLoading: false,
      isLoaded: true,
      isOnError: true,
      errorResponse: { errors: action.payload.errors },
    };
  },
  [CLEAR_BOOKING_ATTENDEES_PACKAGE](): ReduxState {
    return initialState;
  },
});
